import { Animation } from 'blaze-components/Animations/Animation'
import analyzing from './analyzing.json'
import transcribing from './transcribing.json'
import finalizing from './finalizing.json'
import { Text } from 'blaze-ui/Text/Text'
import Styles from './Processing.module.scss'
import { useInterval } from 'react-use'
import { useState } from 'react'

interface Props {
  onCancel: () => void
  label?: string
}

export const Processing = ({ onCancel, label = 'source material' }: Props) => {
  const [step, setStep] = useState(0)
  useInterval(
    () => {
      setStep((step) => step + 1)
    },
    step === 2 ? null : 2.5 * 1000, // 2.5 seconds per slide
  )
  const animationProps = { play: true, style: { width: 85, height: 85 } }

  return (
    <div className={Styles.content}>
      <div />
      <div className={Styles.animation}>
        {step === 0 && (
          <>
            <Animation animationData={analyzing} {...animationProps} />
            <Text variant="primary">Analyzing source...</Text>
          </>
        )}
        {step === 1 && (
          <>
            <Animation animationData={transcribing} {...animationProps} />
            <Text variant="primary">Extracting...</Text>
          </>
        )}
        {step === 2 && (
          <>
            <Animation animationData={finalizing} {...animationProps} />
            <Text variant="primary">finalizing {label}...</Text>
          </>
        )}
      </div>
    </div>
  )
}
